
import React from "react"

import { Container, Row, Col } from 'reactstrap'

import NewsletterSignUpForm from "../../components/MC/NewsletterSignUp"


const FooterEmailSignup = () => (
    <div className="section section_medium section_footer_email">
        <Container>
            <Row>
                <Col md={{ size: 5}}>
                    <h3>Want to help your business grow? <span className="color_purple_light">Sign up and keep up to date with the latest from brillea</span></h3>
                </Col>
                <Col md={{ size: 6, offset: 1 }}>
                    <h4>Send my marketing tips and tricks email to:</h4>
                    
                    <NewsletterSignUpForm
                        Groups={{
                        MC_GROUP_EXPERTS: false,
                        MC_GROUP_USERS: false,
                        MC_GROUP_NEWS: true,
                        }}
                    />
                </Col>
            </Row>
        </Container>
    </div>
)

export default FooterEmailSignup;